/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-useless-escape */
import { ColumnDef } from '@tanstack/react-table';
import { Modal } from 'react-bootstrap';
import { useState, useMemo, useEffect } from 'react';
import { useQuery } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { Form } from 'react-bootstrap';
import Flatpickr from 'react-flatpickr';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { UzbekLatin } from 'flatpickr/dist/l10n/uz_latn.js';
import FeatherIcon from 'feather-icons-react';
import { useSelector } from 'react-redux';

import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTable from 'components/base/AdvanceTable';
import UpdateSelectionAmount from './UpdateSelectionAmount';
import orderItemService from 'service/orderItem';
import orderInService from 'service/orderIn';
import Button from 'components/base/Button';
import orderService from 'service/order';
import { showAlert } from 'store/alert/alert.thunk';
import './styles.scss';
import { useAppContext } from 'providers/AppProvider';
import { useWindowWidth } from 'utils/useWindowSize';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import SupperModal from 'components/modals/SupperModal';

export type ComingResult = {
  product_name: string;
  barcode: string;
  currency: string;
  units: string;
  cost: string;
  remainder: string;
  quantity_asked: string;
  quantity_fact: string;
  quantity_accept: string;
  discrepancies: string;
  amount_discrepancies: string;
  final_price: string;
  total_price: string;
  status: string;
  nomenclature_id: string;
  recipient_id: string;
  guid: string;
  gupid: number;
  discount_percentage: string;
  prevCost: string;
  update_price: boolean;
  discount_id: string;
  amount: string;
  can_update_order_item: boolean;
  nomenclature_pid: number;
  recipient_pid: number;
  package_quantity: any;
  measure_unit_pid: any;
};

const ComingResultTable = () => {
  const { t, i18n } = useTranslation();
  const windowSize: any = useWindowWidth();
  const url = process.env.REACT_APP_CDN_URL;

  const {
    config: { theme }
  } = useAppContext();
  const navigate = useNavigate();

  const { pathname, state } = useLocation();
  const orderPid = Number(pathname.split('/').pop());
  const { orders: ordersName, recipient_pid, sender_pid } = state;
  const dispatch: Dispatch<any> = useDispatch();
  const cashboxId = useSelector((state: any) => state?.shiftId?.shiftId);
  const cashboxPid = useSelector((state: any) => state?.shiftId?.shiftPid);

  const [openAmount, setOpenAmount] = useState(false);
  const [canUpdate, setCanUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState<any>({
    rowId: '',
    nomenclature_id: '',
    recipient_id: '',
    quantity_asked: ''
  });
  const [changedOrderItems, setChangedOrderItems] = useState<any>([]);
  const [showError, setShowError] = useState(false);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [disabledAccept, setDisabledAccept] = useState(false);

  const [isDiscounter, setIsDiscounter] = useState(false);
  const [openSupperModal, setOpenSupperModal] = useState(false);
  const [confirmToDelete, setConfirmToDelete] = useState(false);
  const [delivererOption, setDelivererOption] = useState<any>([]);
  const [selectedDeliverer, setSelectedDelivererId] = useState<any>(null);

  const buyyersBreadcrumbItems: PageBreadcrumbItem[] = [
    {
      label: 'applications',
      url: '/applications/outgoing'
    },
    {
      label: 'incoming',
      url: '/applications/coming'
    },
    {
      label: ordersName || '',
      active: true
    }
  ];

  useQuery(['GET_DELIVERER'], async () => {
    await orderInService
      .getDelivererList({ offset: 0, limit: 100 })
      .then((res: any) => {
        const options = res?.data?.users?.map((option: any) => ({
          value: option.id_number,
          label: (option?.first_name || '') + ' ' + (option?.last_name || '')
        }));
        setDelivererOption(options);
      });
  });

  useQuery(
    ['GET_LEGAL_ENTITY_RELATION'],
    async () => {
      if (recipient_pid && sender_pid) {
        await orderInService
          .getLegalEntityRelationById(sender_pid, recipient_pid)
          .then((res: any) => {
            if (res) {
              const discounter = res?.is_discounter == true ? true : false;

              setIsDiscounter(discounter);
            }
          });
      }
    },
    { enabled: !!recipient_pid && !!sender_pid }
  );

  const { refetch: refetchIn } = useQuery(
    ['GET_RETURN_IN_CAN_UPDATE', orderPid],
    async () => {
      if (orderPid) {
        await orderInService
          .getList({
            offset: 0,
            limit: 1000
          })
          .then((res: any) => {
            if (res) {
              const updatedRes = res.orders.find(
                (el: any) => +el.pid === orderPid
              );
              const canUpdateValue = updatedRes?.can_update ?? false;

              setCanUpdate(canUpdateValue);
            }
          });
      }
    },
    { enabled: !!orderPid }
  );

  const { data, refetch } = useQuery(
    ['GET_ORDER_ITEM', orderPid],
    () => {
      if (orderPid) {
        const res = orderItemService
          .getOrderItemInById(orderPid, {
            offset: 0,
            limit: 1000
          })
          .then((res: any) => {
            return res?.order_items;
          });
        return res;
      }
    },
    { enabled: !!orderPid }
  );

  const handleStartDateChange = (date: Date | Date[]) => {
    if (Array.isArray(date)) {
      const startDateInMillis = date[0].getTime();
      setStartDate(startDateInMillis);
    } else {
      const startDateInMillis = date.getTime();
      setStartDate(startDateInMillis);
    }
  };

  const handleEndDateChange = (date: Date | Date[]) => {
    if (Array.isArray(date)) {
      const endDateInMillis = date[0].getTime();
      setEndDate(endDateInMillis);
    } else {
      const endDateInMillis = date.getTime();
      setEndDate(endDateInMillis);
    }
  };

  const handleAcceptProduct = (id: any) => {
    if (id) {
      setDisabledAccept(true);
      orderItemService
        .updateOrderItemIn(id, {
          state: 6,
          cashbox_id: cashboxId,
          cashbox_pid: cashboxPid
        })
        .finally(() => {
          refetch();
          setDisabledAccept(false);
        });
    }
  };

  // const item = useMemo(() => {
  //   return changedOrderItems.find((item: any) => item.guid === getRowGuid);
  // }, [changedOrderItems, getRowGuid]);

  useMemo(() => {
    const resultData =
      data?.map((items: any, index: number) => {
        const packageQuantity =
          items?.package_quantity !== undefined ? items.package_quantity : 1;
        const quantity =
          items?.quantity_asked !== undefined
            ? String(items.quantity_asked)
            : '0';
        const totalQuantity =
          items?.total_quantity !== undefined
            ? String(items.total_quantity)
            : '0';
        let integerPart = 0;
        let numerator = 0;
        let denominator = 1;

        let integerPartTotal = 0;
        let numeratorTotal = 0;
        let denominatorTotal = 1;

        if (quantity?.includes('.')) {
          [numerator, denominator] = quantity.split('.').map(Number);
          integerPart = numerator; // Whole number part
          denominator = +`0.${denominator}`; // Remainder of the division
        } else {
          integerPart = +quantity;
        }

        if (totalQuantity?.includes('.')) {
          [numeratorTotal, denominatorTotal] = totalQuantity
            .split('.')
            .map(Number);
          integerPartTotal = numeratorTotal; // Whole number part
          denominatorTotal = +`0.${denominatorTotal}`; // Remainder of the division
        } else {
          integerPartTotal = +totalQuantity;
        }

        const multipleFraction = Math?.round(
          +denominatorTotal * packageQuantity
        );

        const quantityDisplay = quantity?.includes('.')
          ? `${integerPart}/${Math.round(+denominator * packageQuantity)}`
          : integerPart;

        const totalQuantityDisplay = totalQuantity?.includes('.')
          ? `${integerPartTotal}/${multipleFraction}`
          : integerPartTotal;

        return {
          guid: items?.id ?? `temp-id-${index}`,
          gupid: items?.pid ?? `temp-id-${index}`,
          can_update_order_item: items?.can_update,
          nomenclature_id: items?.nomenclature_id,
          nomenclature_pid: items?.nomenclature_pid || 0,
          recipient_id: items?.recipient_id,
          recipient_pid: items?.recipient_pid || 0,
          product_name: items?.nomenclature?.name,
          product_id: items?.product_id,
          product_pid: items?.product_pid || 0,
          product_parent_id: items?.product_parent_id,
          product_parent_pid: items?.product_parent_pid || 0,
          barcode: items?.nomenclature?.barcode,
          units: items?.nomenclature?.measure_unit?.name?.[i18n?.language],
          measure_unit_id: items?.nomenclature?.measure_unit?.id,
          measure_unit_pid: items?.nomenclature?.measure_unit?.pid || 0,
          amount: items?.quantity_asked,
          status: items?.state_info?.name?.[i18n?.language],
          update_price: items?.discount?.percentage ? true : false,
          discount_percentage: items?.discount?.percentage ?? 0,
          // currency: inOrderCurrency?.name ?? '',
          currency_id: items?.currency_id,
          currency_pid: items?.currency_pid || 0,
          currency: items?.currency?.name?.[i18n?.language],
          cost: items?.price_wholesale ?? 0,
          prevCost: items?.price_wholesale_org ?? 0,
          history: items?.history ?? 0,
          /* prettier-ignore */
          quantity_asked:
            items?.nomenclature?.measure_unit_pid === 7
              ? quantityDisplay
              : items?.quantity_asked,
          /* prettier-ignore */
          remainder:
            items?.nomenclature?.measure_unit_pid === 7
              ? totalQuantityDisplay
              : items?.total_quantity,
          quantity_fact: items?.quantity_send ?? 0,
          quantity_accept: items?.proved_quantity_by_recipient ?? 0,
          discrepancies: items?.quantity_difference ?? 0,
          /* prettier-ignore */
          amount_discrepancies:
            items?.quantity_difference && items?.price_wholesale
              ? +items.quantity_difference * +items.price_wholesale
              : 0,
          final_price: items?.total_price_in || 0,
          total_price: items?.total_price || 0,
          package_quantity: items?.package_quantity
        };
      }) ?? [];

    if (orderPid) {
      setChangedOrderItems(resultData);
    }

    return resultData;
  }, [data, t, i18n?.language, orderPid]);

  const comingResultTableColumns: ColumnDef<ComingResult>[] = [
    {
      accessorKey: 'order_number',
      header: '№',
      cell: rowData => {
        const orderNumber = rowData.row.index + 1;
        return <div>{orderNumber}</div>;
      },
      meta: {
        headerProps: { style: { width: '5%' } },
        cellProps: { className: 'text-900 p-2' }
      }
    },
    {
      accessorKey: 'product_name',
      header: t('product_names'),
      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'barcode',
      header: t('barcode'),
      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'currency',
      header: t('currency'),
      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'units',
      header: t('measure_unit'),
      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'cost',
      header: t('wholesale_price'),
      // cell: rowData => {
      //   const { cost, prevCost, discount_percentage, update_price } =
      //     rowData.row.original;

      //   const numericDiscountPercentage = +discount_percentage;

      //   // Helper function to format numbers
      //   const formatNumber = (number: number) =>
      //     number % 1 === 0 ? number.toFixed(0) : number.toFixed(2);

      //   return (
      //     <>
      //       {numericDiscountPercentage > 0 && update_price === true ? (
      //         <div className="d-flex gap-2 white-space-nowrap">
      //           {/* Original price with strikethrough */}
      //           <span className="text-muted">{formatNumber(+prevCost)}</span>
      //           {/* Discounted price */}
      //           <span className="text-success">
      //             {formatNumber(+cost)} ({numericDiscountPercentage}%)
      //           </span>
      //         </div>
      //       ) : (
      //         <div className="d-flex gap-2">
      //           <span>{formatNumber(+prevCost)}</span>
      //         </div>
      //       )}
      //     </>
      //   );
      // },
      meta: {
        cellProps: {
          className: 'text-900'
        }
      }
    },

    {
      accessorKey: 'update_price',
      header: t('discount'),
      cell: rowData => {
        const { discount_percentage, prevCost, update_price } =
          rowData.row.original;

        const [value, setValue] = useState(update_price);

        const handleCheckboxChange = (
          e: React.ChangeEvent<HTMLInputElement>,
          index: any
        ) => {
          const checked = e.target.checked;
          setValue(checked);

          const updatedItems = changedOrderItems?.map((item: any, i: any) => {
            const cost = item?.cost ?? 0;

            const discountedCost =
              +discount_percentage > 0
                ? cost * (1 - +discount_percentage / 100)
                : cost;

            if (i === +index) {
              return {
                ...item,
                update_price: checked,
                cost: checked === true ? discountedCost : prevCost
              };
            }
            return item;
          });

          setChangedOrderItems(updatedItems);
        };
        return (
          <div>
            <Form.Group className="printing-check">
              <Form.Check
                type="switch"
                checked={value}
                onChange={e => handleCheckboxChange(e, rowData.row?.id)}
                className="cursor-pointer"
              />
            </Form.Group>
          </div>
        );
      },
      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'remainder',
      header: t('remainder'),
      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'quantity_asked',
      header: t('application_quantity'),
      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'quantity_fact',
      header: t('short_quantity_shipment'),
      cell: rowData => {
        const { package_quantity, measure_unit_pid } = rowData.row.original;
        const amount = String(rowData?.getValue());
        const rowId = rowData?.row?.id;

        const packageQuantity = package_quantity || 1;
        const quantity = amount || '0';

        let integerPart = 0;
        let numerator = 0;
        let denominator = 1;

        if (quantity?.includes('.')) {
          [numerator, denominator] = quantity.split('.').map(Number);
          integerPart = numerator; // Whole number part
          denominator = +`0.${denominator}`; // Remainder of the division
        } else {
          integerPart = +quantity;
        }

        const quantityDisplay = quantity?.includes('.')
          ? `${integerPart}/${Math.round(+denominator * packageQuantity)}`
          : integerPart;

        const handleClick = () => {
          setOpenAmount(false);
          setTimeout(() => {
            setOpenAmount(true);
            setSelectedRowId({
              rowId,
              nomenclature_id: rowData?.row?.original?.nomenclature_id,
              nomenclature_pid: rowData?.row?.original?.nomenclature_pid,
              recipient_id: rowData?.row?.original?.recipient_id,
              recipient_pid: rowData?.row?.original?.recipient_pid,
              quantity_asked: rowData?.row?.original?.quantity_asked,
              barcode: rowData?.row?.original?.barcode
            });
          }, 0);
        };

        return (
          <>
            {canUpdate === true ? (
              <Button
                variant="primary"
                type="button"
                onClick={() => handleClick()}
              >
                {amount}
              </Button>
            ) : (
              <>{measure_unit_pid === 7 ? quantityDisplay : amount}</>
            )}
          </>
        );
      },

      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'quantity_accept',
      header: t('short_qunatity_accept'),
      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'discrepancies',
      header: t('short_no_expoenses'),
      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'amount_discrepancies',
      header: t('asmount_discrepancy'),
      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'final_price',
      header: t('final_purchase_price'),
      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'total_price',
      header: t('final_price'),
      meta: {
        cellProps: { className: 'text-900' }
      }
    },

    {
      accessorKey: 'status',
      header: t('status'),
      meta: {
        cellProps: { className: 'text-900' }
      }
    },
    {
      accessorKey: 'accept_remainder',
      header: t('accept_remainder'),
      cell: rowData => {
        return (
          <>
            {rowData?.row?.original?.can_update_order_item && (
              <Button
                disabled={disabledAccept}
                className="p-2"
                variant="primary"
                onClick={() =>
                  handleAcceptProduct(rowData?.row?.original?.gupid)
                }
              >
                {t('accept_remainder')}
              </Button>
            )}
          </>
        );
      },
      meta: {
        cellProps: {
          className: 'text-900'
        }
      }
    }
  ];

  const table = useAdvanceTable({
    data: changedOrderItems,
    columns: comingResultTableColumns,
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: false
  });

  const sum = changedOrderItems.reduce((acc: any, item: any) => {
    const allCost = item?.total_price === undefined ? 0 : +item.total_price;
    return acc + allCost;
  }, 0);

  const handleSave = () => {
    console.log('startDate', endDate);
    if (startDate === null || endDate === null) {
      setShowError(true);

      dispatch(
        showAlert({
          title: t('dates_are_no_choosen')
        })
      );

      return;
    }

    if (!selectedDeliverer) {
      dispatch(
        showAlert({
          title: t('choose_supplier')
        })
      );
      return;
    }

    const createData = changedOrderItems?.map((el: any) => {
      const quantity = el?.quantity_asked || '0';
      const quantityFact = el?.quantity_fact || '0';

      let integerPart = 0;
      let numerator = 0;
      let denominator = 1; // Default denominator to 1 if no fraction

      let integerPartFact = 0;
      let numeratorFact = 0;
      let denominatorFact = 1;

      const quantityStr = String(quantity);
      // Check if quantity contains '/'
      if (quantityStr?.includes('/')) {
        [numerator, denominator] = quantityStr.split('/').map(Number);

        integerPart = numerator; // Whole number part
        // eslint-disable-next-line
        denominator = denominator; // Remainder of the division
      } else {
        integerPart = +quantityStr;
      }

      const quantityStrFact = String(quantityFact);
      // Check if quantity contains '/'
      if (quantityStrFact?.includes('/')) {
        [numeratorFact, denominatorFact] = quantityStrFact
          .split('/')
          .map(Number);

        integerPartFact = numeratorFact; // Whole number part
        // eslint-disable-next-line
        denominatorFact = denominatorFact; // Remainder of the division
      } else {
        integerPartFact = +quantityStrFact;
      }

      // Package quantity
      const packageQuantity = +el?.package_quantity || 1;

      const fractionalProportionFact =
        (denominatorFact * 100) / packageQuantity;

      // Calculate adjusted quantity
      const adjustedQuantityFact = quantityStr?.includes('/')
        ? `${integerPartFact}.${Math.round(fractionalProportionFact)}`
        : integerPartFact;
      // Calculate the fractional proportion
      const fractionalProportion = (denominator * 100) / packageQuantity;

      // Calculate adjusted quantity
      const adjustedQuantity = quantityStr?.includes('/')
        ? `${integerPart}.${Math.round(fractionalProportion)}`
        : integerPart;

      return {
        barcode: el?.barcode,
        name: el?.product_name,
        package_quantity: el?.package_quantity,
        quantity_asked:
          el?.measure_unit_pid === 7 ? +adjustedQuantity : +el?.quantity_asked,
        quantity_send:
          el?.measure_unit_pid === 7
            ? +adjustedQuantityFact
            : +el?.quantity_fact,
        currency_pid: el?.currency_pid || 0,
        measure_unit_pid: el?.measure_unit_pid || 0,
        nomenclature_pid: el?.nomenclature_pid || 0,
        product_pid: el?.product_pid || 0,
        product_parent_pid: el?.product_parent_pid || 0,
        price: el?.price,
        price_in: el?.price_in,
        price_wholesale: +el?.cost,
        discount_pid: el?.discount_pid || 0,
        state: 5,
        partion_codes: el?.serial_number
      };
    });

    const updateData = {
      order_pid: orderPid || 0,
      order_items: createData
    };

    if (orderPid && startDate !== null && endDate !== null) {
      setLoading(true);

      orderService.getOrderById(orderPid).then((res: any) => {
        if (res) {
          orderInService
            ?.updateOrderOut(orderPid, {
              ...res,
              maturity_date: startDate ?? 0,
              delivered_date: endDate ?? 0,
              deliver_employee_pid: selectedDeliverer,
              state: 5
            })
            .then((inresponse: any) => {
              if (inresponse) {
                orderItemService
                  .createOrderItem(updateData)
                  .then((createres: any) => {
                    if (createres) {
                      dispatch(
                        showAlert({
                          title: t('answered_successfully'),
                          type: 'success'
                        })
                      );
                      navigate('/applications/coming');
                    }
                  })
                  .finally(() => {
                    setShowError(false);
                    refetch();
                    refetchIn();
                  });
              }
            });
        }
      });
    }
  };

  const handleFinished = () => {
    const createData = changedOrderItems?.map((el: any) => {
      const quantity = el?.quantity_asked || '0';

      let integerPart = 0;
      let numerator = 0;
      let denominator = 1; // Default denominator to 1 if no fraction

      const quantityStr = String(quantity);
      // Check if quantity contains '/'
      if (quantityStr?.includes('/')) {
        [numerator, denominator] = quantityStr.split('/').map(Number);

        integerPart = numerator; // Whole number part
        // eslint-disable-next-line
        denominator = denominator; // Remainder of the division
      } else {
        integerPart = +quantityStr;
      }

      // Package quantity
      const packageQuantity = +el?.package_quantity || 1;
      // Calculate the fractional proportion
      const fractionalProportion = (denominator * 100) / packageQuantity;

      // Calculate adjusted quantity
      const adjustedQuantity = quantityStr?.includes('/')
        ? `${integerPart}.${Math.round(fractionalProportion)}`
        : integerPart;

      return {
        barcode: el?.barcode,
        name: el?.product_name,
        package_quantity: el?.package_quantity,
        quantity_asked:
          el?.measure_unit_pid === 7 ? +adjustedQuantity : +quantity,
        quantity_send: el?.quantity_fact,
        currency_pid: el?.currency_pid || 0,
        measure_unit_pid: el?.measure_unit_pid || 0,
        nomenclature_pid: el?.nomenclature_pid || 0,
        product_pid: el?.product_pid || 0,
        product_parent_pid: el?.product_parent_pid || 0,
        price: el?.price,
        price_in: el?.price_in,
        price_wholesale: el?.price_whosale,
        state: 6
      };
    });

    const updateData = {
      order_pid: orderPid || 0,
      order_items: createData
    };

    if (orderPid) {
      setOpenSupperModal(false);
      setConfirmToDelete(false);
      setLoading(true);
      orderService.getOrderById(orderPid).then((res: any) => {
        if (res) {
          orderInService
            ?.updateOrderOut(orderPid, {
              ...res,
              maturity_date: startDate ?? 0,
              delivered_date: endDate ?? 0,
              state: 6
            })
            .then((inresponse: any) => {
              if (inresponse) {
                orderItemService
                  .createOrderItem(updateData)
                  .then((createres: any) => {
                    if (createres) {
                      window.location.reload();
                    }
                  })
                  .finally(() => {
                    setShowError(false);
                    refetch();
                    refetchIn();
                  });
              }
            });
        }
      });
    }
  };

  const getFlatpickrLocale = () => {
    switch (i18n.language) {
      case 'ru':
        return Russian;
      case 'uz':
        return UzbekLatin;
      default:
        return undefined;
    }
  };

  const handleExcelById = () => {
    setLoadingExcel(true);
    const customFilename: string = 'Закуп по накладной.xlsx';

    // Fetch report and trigger download
    orderInService
      ?.getOrderInListExcel({ order_pid: orderPid, order_type: 'IN' })
      .then((res: any) => {
        if (res?.filename !== '') {
          const resUrl = `${url}${res?.filename}`;
          const link = document.createElement('a');
          link.href = resUrl;
          link.download = customFilename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        setLoadingExcel(false);
      });
  };

  useEffect(() => {
    const today = new Date();

    setStartDate(today.getTime());
    setEndDate(today.getTime());
  }, []);

  useEffect(() => {
    if (confirmToDelete) {
      handleFinished();
    }
  }, [confirmToDelete, refetch]);

  return (
    <div>
      <PageBreadcrumb items={buyyersBreadcrumbItems} />

      <div className="d-flex align-items-center justify-content-between gap-2 mb-5">
        <h2>{ordersName || ''}</h2>
        {!canUpdate && (
          <Button
            className="d-flex align-items-center gap-2"
            style={{ height: '48px' }}
            variant="outline-primary"
            onClick={handleExcelById}
            loading={loadingExcel}
            loadingPosition="start"
          >
            <FeatherIcon icon="upload-cloud" size={20} />
            {windowSize > 768 && t('export')}
          </Button>
        )}
      </div>

      <AdvanceTableProvider {...table}>
        <div className="mt-4 mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-300 position-relative top-1">
          <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />
          <AdvanceTableFooter pagination />
        </div>
      </AdvanceTableProvider>

      <div
        className={
          windowSize < 768
            ? 'd-flex flex-column gap-2'
            : 'd-flex justify-content-end text-center gap-3 p-3 mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-300'
        }
      >
        <div
          className="box"
          style={{
            border: `1px solid ${theme === 'dark' ? '#373e53' : '#f5f5f5'}`,
            backgroundColor: `${theme === 'dark' ? '#141824' : '#fff'}`,
            borderRadius: '8px',
            display: 'flex',
            justifyContent: 'space-between',
            gap: '10px',
            alignItems: 'center',
            padding: '8px',
            color: `${theme === 'dark' ? '#9fa6bc' : '#000'}`
          }}
        >
          <p className="mb-0 text-bold">{t('total_amount')}:</p>
          <span>{sum ?? 0}</span>
        </div>

        <div className="d-flex gap-2">
          <Form.Group>
            <div className="react-select-container">
              <Form.Floating>
                <Form.Select
                  onChange={(e: any) => {
                    const selectedOption = delivererOption.find(
                      (option: any) =>
                        Number(option.value) === Number(e.target.value)
                    );
                    if (selectedOption) {
                      setSelectedDelivererId(selectedOption?.value);
                    }
                  }}
                >
                  <option className="d-none" value=""></option>
                  {delivererOption?.map((option: any) => (
                    <option
                      key={option.value}
                      value={option.value}
                      className="option"
                    >
                      {option.label}
                    </option>
                  ))}
                </Form.Select>

                <label htmlFor="floatingInputCustom">{t('delivery_man')}</label>
              </Form.Floating>
            </div>
          </Form.Group>

          <Form.Group className="md-4">
            <Form.Floating>
              <Flatpickr
                className={classNames('form-control', {
                  error: showError === true ? true : false
                })}
                options={{
                  nextArrow: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"/></svg>`,
                  prevArrow: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"/></svg>`,
                  locale: getFlatpickrLocale(),
                  monthSelectorType: 'static',
                  onDayCreate: (...[, , , dayElem]) => {
                    if (
                      dayElem.dateObj.getDay() === 5 ||
                      dayElem.dateObj.getDay() === 6
                    ) {
                      dayElem.className += ' weekend-days';
                    }
                  },
                  dateFormat: 'M j, Y',
                  disableMobile: true
                }}
                value={startDate}
                onChange={handleStartDateChange}
                placeholder={t('maturity_date')}
              />
              <label htmlFor="floatingInputCustom">{t('maturity_date')}</label>
            </Form.Floating>
          </Form.Group>

          <Form.Group className="md-4">
            <Form.Floating>
              <Flatpickr
                className={classNames('form-control', {
                  error: showError === true ? true : false
                })}
                options={{
                  nextArrow: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"/></svg>`,
                  prevArrow: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"/></svg>`,
                  locale: getFlatpickrLocale(),
                  monthSelectorType: 'static',
                  onDayCreate: (...[, , , dayElem]) => {
                    if (
                      dayElem.dateObj.getDay() === 5 ||
                      dayElem.dateObj.getDay() === 6
                    ) {
                      dayElem.className += ' weekend-days';
                    }
                  },
                  dateFormat: 'M j, Y',
                  disableMobile: true
                }}
                value={endDate}
                onChange={handleEndDateChange}
                placeholder={t('date_delivery')}
              />
              <label htmlFor="floatingInputCustom">{t('date_delivery')}</label>
            </Form.Floating>
          </Form.Group>
        </div>

        <div className="d-flex gap-2">
          <Button
            disabled={orderPid === 0 || !canUpdate || loading}
            variant="primary"
            onClick={() => handleSave()}
            loading={loading}
            loadingPosition="start"
          >
            {t('answer')}
          </Button>
          <Button
            disabled={orderPid === 0 || !canUpdate || loading}
            variant="danger"
            onClick={() => setOpenSupperModal(true)}
            loading={loading}
            loadingPosition="start"
          >
            {t('reject')}
          </Button>
        </div>
      </div>

      <SupperModal
        show={openSupperModal}
        setShow={setOpenSupperModal}
        setConfirm={setConfirmToDelete}
        title={t('reject')}
        bodyText={t('you_want_delete')}
      />

      <Modal
        show={openAmount}
        onHide={() => setOpenAmount(false)}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t('selection_purchase')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UpdateSelectionAmount
            setOpenAmount={setOpenAmount}
            changedOrderItems={changedOrderItems}
            setChangedOrderItems={setChangedOrderItems}
            selectedRowId={selectedRowId}
            isDiscounter={isDiscounter}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ComingResultTable;
